import { useState, useEffect } from 'react';
import { useBooleanFlagValue, useWhenProviderReady } from '@openfeature/react-sdk';

interface UseInteractiveRollkarteFlagResult {
  enabled: boolean;
  loading: boolean;
}

/**
 * Feature flag hook for the interactive Rollkarte drag-and-drop feature.
 * Reads the `interactive_rollkarte` flag from Flagsmith via OpenFeature.
 * When enabled, the Rollkarte export dialog shows a toggle that lets users
 * drag-and-drop shipment rows between routes for print layout adjustments.
 */
export function useInteractiveRollkarteFlag(): UseInteractiveRollkarteFlagResult {
  const value = useBooleanFlagValue('interactive_rollkarte', false);
  const isReady = useWhenProviderReady();

  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Stay resolved while the provider reconciles after a token refresh.
    if (isReady) {
      setEnabled(value);
      setLoading(false);
    }
  }, [value, isReady]);

  return { enabled, loading };
}
